// extracted by mini-css-extract-plugin
export default {"r_l":"_23a51ba4ae dff1ca7bf0","t":"e334d3cf09"};